import { useMemo } from 'react';

import styled from '@emotion/styled';

import { FlagComponentProps } from '..';

import Flags from './flags.png';
import { countryCodes } from './constants';

const StyledContainer = styled.span<Pick<FlagComponentProps, 'size'>>`
  display: inline-block;
  line-height: 16px;
  width: ${(props) => props.size || '1em'};
`;

const StyledFlag = styled.div<Pick<FlagComponentProps, 'size'>>`
  background: url(${Flags}) no-repeat;
  height: 15px;
`;

export function FlagSvgFallback({ countryIsoCode, size, ...other }: FlagComponentProps): JSX.Element {
  const countryIndex = useMemo(() => countryCodes[countryIsoCode.toLowerCase()], [countryIsoCode]);
  const backgroundPositionY = countryIndex * 15 * -1;

  return (
    <StyledContainer {...other}>
      <StyledFlag
        style={{
          backgroundPositionY: backgroundPositionY,
        }}
        size={size}
      />
    </StyledContainer>
  );
}
